import "./Navbar.css"
import BuyMeACoffeeButton from "../Donation/BuyMeACoffeeButton"
import { NavHashLink as NavLink } from 'react-router-hash-link';

import {
    FaHome,
    FaInstagram,
    FaTiktok,
    FaYoutube
} from 'react-icons/fa';

function Navbar({ primaryColor='#000000', position='relative' }) {
    return (
        <nav className="navbar-container" style={{ '--position': position }}>
            {(
                <ul className="navbar-nav" style={{ '--primary-color': primaryColor }}>
                    <li className="navbar-home">
                    <NavLink
                        to='/'>
                        JD's Kitchen
                    </NavLink>
                </li>
                </ul>
                
                
            )}
            <ul className="navbar-nav" style={{ '--primary-color': primaryColor }}>
        

                <li className="navbar-item">
                    <a href="https://jds-kitchen.square.site" target="_blank" rel="noopener noreferrer">Shop</a>
                </li>
                {/* <li className="navbar-item">
                    <NavLink
                        to='/about'>
                        About Us
                    </NavLink>
                </li> */}
                <li className="navbar-item">
                    <NavLink
                        to='#menu'
                        smooth={true}
                        spy='true'
                        duration={2000}
                    >
                       Menu
                    </NavLink>
                </li>
                <li className="navbar-item">
                    <NavLink
                        to='#contact'
                        smooth={true}
                        spy='true'
                        duration={2000}
                    >
                       Contact
                    </NavLink>
                </li>
                {/* <li className="navbar-item">
                    <a data-formkit-toggle="3df9b1e41a" href="https://jackydam.kit.com/3df9b1e41a">Subscribe</a>                
                </li> */}

                <a href="https://www.youtube.com/@jdskitchenbakes/?utm_source=jdskitchen&utm_medium=navbar&utm_campaign=social_links" target="_blank" rel="noopener noreferrer">
                    <FaYoutube
                        className='navbar-social navbar-icons'
                        style={{ color: primaryColor }}
                        aria-label='Youtube'
                    />
                </a>
                <a href="https://www.instagram.com/jdskitchenbakes/?utm_source=jdskitchen&utm_medium=navbar&utm_campaign=social_links" target="_blank" rel="noopener noreferrer">
                    <FaInstagram
                        className='navbar-social navbar-icons'
                        style={{ color: primaryColor }}
                        aria-label='Instagram'
                    />
                </a>
                <a href="https://www.tiktok.com/@jdskitchenbakes/?utm_source=jdskitchen&utm_medium=navbar&utm_campaign=social_links" target="_blank" rel="noopener noreferrer">
                    <FaTiktok
                        className='navbar-social navbar-icons'
                        style={{ color: primaryColor }}
                        aria-label='Tiktok'
                    />
                </a>


                <BuyMeACoffeeButton />
            </ul>

        </nav>
    );
}

export default Navbar